// Copyright (c) 2021, Elicenciamento. All rights reserved.

import breakpoints from "./breakpoints";

const mdUp = `@media (min-width: ${breakpoints.values.md}px)`;

const fontFamily = {
  rubik: '"Rubik", sans-serif',
};

const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
};

const typography = {
  h1: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.light,
    fontSize: "3.5rem",
    lineHeight: 1.143,
    letterSpacing: "-0.09375em",
    [mdUp]: {
      fontSize: "6rem",
      lineHeight: 1.167,
    },
  },
  h2: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.light,
    fontSize: "2.375rem",
    lineHeight: 1.16,
    letterSpacing: "-0.03125em",
    [mdUp]: {
      fontSize: "3.75rem",
      lineHeight: 1.2,
    },
  },
  h3: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.regular,
    fontSize: "2rem",
    lineHeight: 1.25,
    letterSpacing: "0em",
    [mdUp]: {
      fontSize: "2.9991rem",
      lineHeight: 1.167,
    },
  },
  h4: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.regular,
    fontSize: "1.5rem",
    lineHeight: 1.334,
    letterSpacing: "0.015625em",
    [mdUp]: {
      fontSize: "2.0243rem",
      lineHeight: 1.235,
    },
  },
  h5: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.regular,
    fontSize: "1.25rem",
    lineHeight: 1.4,
    letterSpacing: "0em",
    [mdUp]: {
      fontSize: "1.4993rem",
      lineHeight: 1.334,
    },
  },
  h6: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.medium,
    fontSize: "1.125rem",
    lineHeight: 1.56,
    letterSpacing: "0.009375em",
    [mdUp]: {
      fontSize: "1.25rem",
      lineHeight: 1.6,
    },
  },
  subtitle1: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.regular,
    fontSize: "1rem",
    lineHeight: 1.75,
    letterSpacing: "0.009375em",
  },
  subtitle2: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.medium,
    fontSize: "0.875rem",
    lineHeight: 1.71,
    letterSpacing: "0.00625em",
  },
  body1: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.regular,
    fontSize: "1rem",
    lineHeight: 1.5,
    letterSpacing: "0.03125em",
  },
  body2: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.regular,
    fontSize: "0.875rem",
    lineHeight: 1.43,
    letterSpacing: "0.015625em",
  },
  button: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.medium,
    fontSize: "0.875rem",
    lineHeight: 1.71,
    letterSpacing: "0.025em",
  },
  caption: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.regular,
    fontSize: "0.75rem",
    lineHeight: 1.67,
    letterSpacing: "0.025em",
  },
  overline: {
    fontFamily: fontFamily.rubik,
    fontWeight: fontWeight.regular,
    fontSize: "0.75rem",
    lineHeight: 2.67,
    letterSpacing: "0.09375em",
  },
};

export default typography;
